export default class AppUrls{ 

   static  AppApiBaseUrls="https://productionapi.alumniconnect.co.ke/api/";
   static AppCardPaymentUrl="https://alumniconnect.co.za/api/card-processing";
}
//CI/CD
